// @ts-nocheck
import { CNPJ as checkCnpj } from '@lbca/validations';
import { replaceAllNotAlphanumericTextCursor } from '../replaceWithCursorPosition';

export class MaskCnpj {
  private maxLength = 14;

  public insertIconValidate = true;

  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotAlphanumericTextCursor(value, cursorPosition);

    if (newValue.length > this.maxLength) {
      return {
        newValue: newValue.substr(0, this.maxLength),
        newCursorPosition: newCursorPosition >= this.maxLength ? this.maxLength : newCursorPosition,
      };
    }
    return { newValue, newCursorPosition };
  }

  public setMask(
    value: string | number,
    cursorPosition
  ): { formatedValue; formatedCursorPosition } {
    try {
      const param = typeof value === 'number' ? String(value) : value;
      if (param.length <= 2) {
        return { formatedValue: param, formatedCursorPosition: cursorPosition };
      } else if (param.length <= 5) {
        const formatedValue = param.replace(/^([A-Z0-9]{2})([A-Z0-9]{1,3})$/, '$1.$2');
        const formatedCursorPosition = cursorPosition < 2 ? cursorPosition : cursorPosition + 1;
        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (param.length <= 8) {
        const formatedValue = param.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{1,3})/, '$1.$2.$3');

        let formatedCursorPosition = cursorPosition;
        if (cursorPosition >= 2) formatedCursorPosition++;
        if (cursorPosition >= 5) formatedCursorPosition++;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (param.length <= 12) {
        const formatedValue = param.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{1,4})/, '$1.$2.$3/$4');

        let formatedCursorPosition = cursorPosition;
        if (cursorPosition >= 2) formatedCursorPosition++;
        if (cursorPosition >= 5) formatedCursorPosition++;
        if (cursorPosition >= 8) formatedCursorPosition++;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else {
        const firstPart = param.substring(0,12);
        const verifierDigits = param.substring(12).replace(/[^\d]/g, '');
        const newParam = `${firstPart}${verifierDigits}`;
        const formatedValue = newParam.replace(
          /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{1,2})/,
          '$1.$2.$3/$4-$5'
        );

        let formatedCursorPosition = cursorPosition;
        if (cursorPosition >= 2) formatedCursorPosition++;
        if (cursorPosition >= 5) formatedCursorPosition++;
        if (cursorPosition >= 8) formatedCursorPosition++;
        if (cursorPosition >= 12) formatedCursorPosition++;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      }
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }

  // public validation = (value, focusOut): Array<{ status: 'ok' | 'warn' | 'err', msgCode: string }> => {
  //   if (!value) return [];
  //   let status: 'ok' | 'warn' | 'err' = 'warn';
  //   let msgCode = 'cnpj-incomplete';

  //   if (value.length >= this.maxLength) {
  //     if (checkCnpj(value)) {
  //       msgCode = 'cnpj-valid';
  //       status = 'ok';
  //     } else {
  //       status = 'err';
  //       msgCode = 'cnpj-notValid';
  //     }
  //   } else if (focusOut) status = 'err';

  //   return [{ status, msgCode }];

  // }

  public validate(value) {
    const { newValue: valueWithoutMask } = replaceAllNotAlphanumericTextCursor(value, value.length);
    return checkCnpj(valueWithoutMask);
  }
  public getMaskErrors(value) {
    return [this.assets.labels.feedbacks.masks['CNPJ']];
  }
}
